import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";

@Component({
  selector: "[wall-type-5]",
  templateUrl: "./wall-type-5.component.html",
  styleUrls: ["./wall-type-5.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WallType5Component {
  height = input<number>();

  leftWallPoints = computed(() => this.getWallPoints(this.height(), "left"));
  rightWallPoints = computed(() => this.getWallPoints(this.height(), "right"));

  // Monitoring
  private getWallPoints(baseHeight: number, wallSide: "left" | "right"): string {
    const wallData = {
        left: `M0 101 L178 208 L178 ${baseHeight + 37} L0 ${baseHeight - 68} Z`,
        right: `M178 208 L299 135 L299 ${baseHeight - 38} L178 ${baseHeight + 37} Z`
    };

    return wallData[wallSide];
  }
}
